// Системні сповіщення браузера (Notification API) — коли вкладка SPARK у фоні
// або згорнута. У desktop (Tauri) не використовується: там свої Windows-тости
// (desktopNotify). Працює, поки вкладка відкрита; при закритій — Web Push (pushNotify.js),
// і якщо push на пристрої увімкнено, цей канал мовчить (інакше було б дві копії).
import { isDesktopApp } from './desktopNotify';
import { isPushActive } from './pushNotify';

export const browserNotifySupported = () => typeof window !== 'undefined' && 'Notification' in window && !isDesktopApp();

/** 'granted' | 'denied' | 'default' | 'unsupported' */
export const browserNotifyPermission = () => (browserNotifySupported() ? window.Notification.permission : 'unsupported');

/** Запит дозволу (лише з кліку користувача). Повертає підсумковий стан. */
export async function requestBrowserNotifyPermission() {
  if (!browserNotifySupported()) return 'unsupported';
  try {
    return await window.Notification.requestPermission();
  } catch {
    return window.Notification.permission;
  }
}

/**
 * Показати системне сповіщення, якщо є дозвіл і вкладка не перед очима
 * (інакше вистачить in-app тосту). onClick(target) — навігація після фокусу.
 */
export function browserNotify(toast, onClick) {
  if (!toast || browserNotifyPermission() !== 'granted') return;
  if (isPushActive()) return; // на цьому пристрої те саме сповіщення прийде через Web Push — без дубля
  if (!document.hidden && document.hasFocus?.()) return;
  const options = { body: [toast.body, toast.line2].filter(Boolean).join('\n'), tag: toast.key, icon: '/android-chrome-192x192.png' };
  try {
    const n = new window.Notification(toast.title, options);
    n.onclick = () => {
      window.focus();
      if (toast.target) onClick?.(toast.target);
      n.close();
    };
  } catch {
    // Android Chrome: конструктор заборонено — лише через service worker (без переходу по кліку)
    navigator.serviceWorker?.ready
      .then((reg) => reg.showNotification(toast.title, options))
      .catch((e) => console.warn('[browserNotify]', e));
  }
}
